import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaSnapshot from './media-snapshot-model'
import {
  delete_mediaSnapshot,
  load_mediaSnapshots,
  store_mediaSnapshot,
} from './mediaSnapshot-service'

export const LoadMediaSnapshotsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaSnapshot',
  async (params: { uid: string }) => {
    return await load_mediaSnapshots(params)
  },
)

export const CreateMediaSnapshotAsync = createAsyncThunk<any, any>(
  'composer/create/mediaSnapshot',
  async (params: MediaSnapshot) => {
    return await store_mediaSnapshot(params)
  },
)

export const DeleteMediaSnapshotAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaSnapshot',
  async (params) => {
    return await delete_mediaSnapshot(params)
  },
)
